(function () {
  "use strict";

  angular.module("appback").controller("ConnectController", ConnectController);

  ConnectController.$inject = ["$http", "$interval"];

  function ConnectController($http, $interval) {
    var vm = this;

    var QR_REFRESH_MS = 20000; // WAHA rota el QR cada ~20s (tiempo estándar de WAHA)
    var STATUS_POLL_MS = 3000;

    // Los polls de estado/QR no deben disparar la barra de carga global.
    // ignoreLoadingBar va como propiedad del config de $http (no dentro de
    // headers): la lee angular-loading-bar en config.ignoreLoadingBar.
    var IGNORE_LOADING_BAR = { ignoreLoadingBar: true };

    vm.whatsapp = {
      connected: false,
      phone: null,
      status: null,
      qr: null,
      loading: false,
    };

    vm.openWhatsapp = openWhatsapp;
    vm.disconnectWhatsapp = disconnectWhatsapp;
    vm.whatsappStatusMessage = whatsappStatusMessage;

    vm.trackedNumbers = {
      list: [],
      newPhone: "",
      loading: false,
    };
    vm.addTrackedNumber = addTrackedNumber;
    vm.toggleTrackedNumber = toggleTrackedNumber;

    var whatsappModal = null;
    var statusTimer = null;
    var qrTimer = null;
    var restartAttempted = false;

    activate();

    function activate() {
      refreshWhatsappStatus();

      var modalEl = document.getElementById("whatsappModal");
      if (modalEl) {
        modalEl.addEventListener("hidden.bs.modal", stopTimers);
      }
    }

    function getWhatsappModal() {
      if (!whatsappModal) {
        whatsappModal = new bootstrap.Modal(document.getElementById("whatsappModal"));
      }
      return whatsappModal;
    }

    function stopQrTimer() {
      if (qrTimer) {
        $interval.cancel(qrTimer);
        qrTimer = null;
      }
    }

    function stopTimers() {
      if (statusTimer) {
        $interval.cancel(statusTimer);
        statusTimer = null;
      }
      stopQrTimer();
    }

    function refreshWhatsappStatus() {
      return $http
        .get("/backend/site/waha-status", IGNORE_LOADING_BAR)
        .then(function (res) {
          applyStatus(res.data);
        })
        .catch(function () {
          vm.whatsapp.status = "ERROR";
        });
    }

    function applyStatus(data) {
      if (!data || !data.success) {
        vm.whatsapp.status = "ERROR";
        return;
      }

      vm.whatsapp.status = data.status;

      if (data.status === "WORKING" && data.phone) {
        var wasConnected = vm.whatsapp.connected;
        vm.whatsapp.connected = true;
        vm.whatsapp.phone = data.phone;
        stopTimers();
        if (!wasConnected) {
          refreshTrackedNumbers();
        }
        return;
      }

      vm.whatsapp.connected = false;

      if (data.status === "SCAN_QR_CODE") {
        if (!qrTimer) {
          refreshQr();
          qrTimer = $interval(refreshQr, QR_REFRESH_MS);
        }
      } else {
        // Cualquier otro estado (FAILED, STARTING, STOPPED...) ya no tiene
        // QR vigente (pedirlo devuelve 422 si la sesión no está en
        // SCAN_QR_CODE). Se deja de pedir el QR pero se sigue consultando
        // el status: puede recuperarse solo, y si no, el usuario ve el
        // estado actualizado en vez de quedarse pegado en el último visto.
        stopQrTimer();
      }

      if (data.status === "FAILED" && !restartAttempted) {
        restartAttempted = true;
        $http.post("/backend/site/waha-restart", {}, IGNORE_LOADING_BAR);
      }
    }

    function refreshQr() {
      $http
        .get("/backend/site/waha-qr", IGNORE_LOADING_BAR)
        .then(function (res) {
          if (res.data.success) {
            vm.whatsapp.qr = res.data.qr;
          }
        })
        .catch(function () {
          // La sesión ya se movió de SCAN_QR_CODE (p.ej. a FAILED) entre
          // este pedido y el último status conocido: no tiene sentido
          // seguir pidiendo QR, pero el status sigue consultándose solo.
          stopQrTimer();
        });
    }

    function whatsappStatusMessage() {
      switch (vm.whatsapp.status) {
        case "SCAN_QR_CODE":
          return "Escanea el código QR desde WhatsApp > Dispositivos vinculados.";
        case "FAILED":
          return restartAttempted
            ? "La conexión falló, reintentando…"
            : "La conexión falló. Cierra el modal e inténtalo de nuevo.";
        case "ERROR":
          return "No se pudo consultar el estado. Inténtalo de nuevo.";
        case "DISCONNECTED":
          return "Desconectado correctamente.";
        default:
          return vm.whatsapp.loading ? "Iniciando conexión…" : "Preparando sesión…";
      }
    }

    function openWhatsapp() {
      getWhatsappModal().show();

      if (vm.whatsapp.connected) {
        return;
      }

      startWhatsappSession();
    }

    function startWhatsappSession() {
      stopTimers();
      restartAttempted = false;
      vm.whatsapp.loading = true;
      vm.whatsapp.qr = null;

      $http
        .post("/backend/site/waha-start", {}, IGNORE_LOADING_BAR)
        .then(function () {
          vm.whatsapp.loading = false;
          refreshWhatsappStatus();
          statusTimer = $interval(refreshWhatsappStatus, STATUS_POLL_MS);
        })
        .catch(function () {
          vm.whatsapp.loading = false;
          vm.whatsapp.status = "ERROR";
        });
    }

    function disconnectWhatsapp() {
      return $http.post("/backend/site/waha-disconnect", {}, IGNORE_LOADING_BAR).then(function () {
        stopTimers();
        vm.whatsapp.connected = false;
        vm.whatsapp.phone = null;
        vm.whatsapp.qr = null;
        vm.whatsapp.status = "DISCONNECTED";
        vm.trackedNumbers.list = [];
      });
    }

    // -- Filtro de números de WhatsApp a trackear ---------------------------
    //
    // No hay una entidad propia para esta preferencia: el backend la guarda
    // reutilizando common\models\Mensaje::seguimiento sobre los mensajes
    // entrantes de WhatsApp (ver backend\controllers\SiteController::
    // actionWahaTrackedNumbers()/actionWahaTrackNumber()). Sin ningún número
    // marcado se trackea todo; en cuanto se marca uno, el resto queda afuera
    // hasta que también se marque.

    function refreshTrackedNumbers() {
      return $http
        .get("/backend/site/waha-tracked-numbers", IGNORE_LOADING_BAR)
        .then(function (res) {
          if (res.data && res.data.success) {
            vm.trackedNumbers.list = res.data.numbers || [];
          }
        });
    }

    function addTrackedNumber() {
      var phone = (vm.trackedNumbers.newPhone || "").trim();
      if (!phone) {
        return;
      }

      vm.trackedNumbers.loading = true;

      postForm("/backend/site/waha-track-number", { phone: phone })
        .then(function () {
          vm.trackedNumbers.newPhone = "";
          return refreshTrackedNumbers();
        })
        .finally(function () {
          vm.trackedNumbers.loading = false;
        });
    }

    function toggleTrackedNumber(n) {
      var url = n.tracked ? "/backend/site/waha-track-number" : "/backend/site/waha-untrack-number";

      postForm(url, { phone: n.phone }).catch(function () {
        // No se pudo guardar el cambio: se revierte el switch a su estado anterior.
        n.tracked = !n.tracked;
      });
    }

    // -- Gmail / Microsoft 365 (RustMailer) --------------------------------
    //
    // A diferencia de WhatsApp, acá no hay QR: se le pide el email de la
    // casilla, RustMailer genera un link de autorización OAuth2 de
    // Google/Microsoft que se abre en una pestaña nueva, y este front sigue
    // consultando actionRustmailerStatus (poll) hasta que RustMailer haya
    // guardado el token tras la autorización.

    vm.email = {
      gmail: emptyEmailProviderState("Gmail"),
      office365: emptyEmailProviderState("Microsoft 365"),
    };
    vm.activeEmailProvider = null;

    vm.openEmailProvider = openEmailProvider;
    vm.submitEmailProvider = submitEmailProvider;
    vm.disconnectEmailProvider = disconnectEmailProvider;

    var emailModal = null;
    var emailStatusTimer = null;

    refreshEmailStatus("gmail");
    refreshEmailStatus("office365");

    var emailModalEl = document.getElementById("emailModal");
    if (emailModalEl) {
      emailModalEl.addEventListener("hidden.bs.modal", stopEmailTimer);
    }

    function emptyEmailProviderState(label) {
      return {
        label: label,
        connected: false,
        address: null,
        status: null,
        loading: false,
        error: null,
        // Se pone en true recién cuando el usuario aprieta "Autorizar acceso"
        // en esta sesión. El poll inicial (refreshEmailStatus al cargar la
        // página) puede encontrar un status PENDING viejo, de un intento
        // anterior que quedó a medias: sin este flag, emailStatusMessage
        // mostraría "esperá un momento" apenas se abre el modal, sin que el
        // usuario haya tocado nada.
        polling: false,
        form: { email: "" },
      };
    }

    function getEmailModal() {
      if (!emailModal) {
        emailModal = new bootstrap.Modal(document.getElementById("emailModal"));
      }
      return emailModal;
    }

    function stopEmailTimer() {
      if (emailStatusTimer) {
        $interval.cancel(emailStatusTimer);
        emailStatusTimer = null;
      }
    }

    function refreshEmailStatus(key) {
      return $http
        .get("/backend/site/rustmailer-status", angular.extend({ params: { provider: key } }, IGNORE_LOADING_BAR))
        .then(function (res) {
          applyEmailStatus(key, res.data);
        })
        .catch(function () {
          vm.email[key].status = "ERROR";
        });
    }

    function applyEmailStatus(key, data) {
      var provider = vm.email[key];

      if (!data || !data.success) {
        provider.status = "ERROR";
        return;
      }

      provider.status = data.status;

      if (data.status === "CONNECTED") {
        provider.connected = true;
        provider.address = data.email;
        stopEmailTimer();
      } else {
        provider.connected = false;
      }
    }

    function emailStatusMessage(key) {
      var provider = vm.email[key];
      switch (provider.status) {
        case "PENDING":
          // Un PENDING que no viene de un intento iniciado en esta sesión es
          // un registro viejo sin autorizar: no mostramos el mensaje de
          // espera, para no dar a entender que hay algo en curso.
          return provider.polling ? "Autoriza el acceso en la pestaña que se abrió y espera un momento…" : "";
        case "ERROR":
          return "No se pudo consultar el estado. Inténtalo de nuevo.";
        default:
          return provider.loading ? "Iniciando conexión…" : "";
      }
    }

    vm.emailStatusMessage = emailStatusMessage;

    function openEmailProvider(key) {
      stopEmailTimer();
      vm.activeEmailProvider = key;

      var provider = vm.email[key];
      provider.error = null;
      if (!provider.connected) {
        provider.form.email = "";
      }

      getEmailModal().show();
    }

    function submitEmailProvider() {
      var key = vm.activeEmailProvider;
      var provider = vm.email[key];
      var email = (provider.form.email || "").trim();

      if (!email) {
        return;
      }

      provider.loading = true;
      provider.error = null;

      postForm("/backend/site/rustmailer-start", { provider: key, email: email })
        .then(function (res) {
          provider.loading = false;

          if (res.data && res.data.url) {
            window.open(res.data.url, "_blank", "noopener");
          }

          provider.polling = true;
          stopEmailTimer();
          refreshEmailStatus(key);
          emailStatusTimer = $interval(function () {
            refreshEmailStatus(key);
          }, STATUS_POLL_MS);
        })
        .catch(function (res) {
          provider.loading = false;
          provider.error =
            (res.data && res.data.error) || "No se pudo iniciar la conexión. Inténtalo de nuevo.";
        });
    }

    function disconnectEmailProvider(key) {
      return postForm("/backend/site/rustmailer-disconnect", { provider: key }).then(function () {
        vm.email[key].connected = false;
        vm.email[key].address = null;
        vm.email[key].polling = false;
        vm.email[key].status = null;
      });
    }

    // -- Telegram -----------------------------------------------------------
    //
    // A diferencia de WhatsApp (QR) y Gmail/Microsoft 365 (OAuth2), acá no
    // hay nada que esperar: el usuario pega el token de su bot (creado con
    // @BotFather), el backend lo valida y registra el webhook en el mismo
    // pedido (ver backend\controllers\SiteController::actionTelegramStart()),
    // así que alcanza con refrescar el status una vez al terminar, sin poll.

    vm.telegram = {
      connected: false,
      username: null,
      status: null,
      loading: false,
      error: null,
      form: { token: "" },
    };

    vm.openTelegram = openTelegram;
    vm.submitTelegram = submitTelegram;
    vm.disconnectTelegram = disconnectTelegram;

    var telegramModal = null;

    refreshTelegramStatus();

    function getTelegramModal() {
      if (!telegramModal) {
        telegramModal = new bootstrap.Modal(document.getElementById("telegramModal"));
      }
      return telegramModal;
    }

    function refreshTelegramStatus() {
      return $http
        .get("/backend/site/telegram-status", IGNORE_LOADING_BAR)
        .then(function (res) {
          applyTelegramStatus(res.data);
        })
        .catch(function () {
          vm.telegram.status = "ERROR";
        });
    }

    function applyTelegramStatus(data) {
      if (!data || !data.success) {
        vm.telegram.status = "ERROR";
        return;
      }

      vm.telegram.status = data.status;

      if (data.status === "CONNECTED") {
        vm.telegram.connected = true;
        vm.telegram.username = data.username;
      } else {
        vm.telegram.connected = false;
      }
    }

    function openTelegram() {
      vm.telegram.error = null;
      if (!vm.telegram.connected) {
        vm.telegram.form.token = "";
      }

      getTelegramModal().show();
    }

    function submitTelegram() {
      var token = (vm.telegram.form.token || "").trim();
      if (!token) {
        return;
      }

      vm.telegram.loading = true;
      vm.telegram.error = null;

      postForm("/backend/site/telegram-start", { token: token })
        .then(function () {
          vm.telegram.loading = false;
          return refreshTelegramStatus();
        })
        .catch(function (res) {
          vm.telegram.loading = false;
          vm.telegram.error =
            (res.data && res.data.error) || "No se pudo conectar el bot. Intentá de nuevo.";
        });
    }

    function disconnectTelegram() {
      return postForm("/backend/site/telegram-disconnect", {}).then(function () {
        vm.telegram.connected = false;
        vm.telegram.username = null;
        vm.telegram.status = null;
      });
    }

    function postForm(url, data) {
      return $http.post(
        url,
        jQuery.param(data),
        angular.extend(
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } },
          IGNORE_LOADING_BAR
        )
      );
    }
  }
})();
